import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { getLastResults, getDetailResults } from "../../../apiservices/CasionApi";
import RefResultModal from "../../casinoComponents/refResultModal";
import Teen1DayResultBody from "../../casinoComponents/refResultModal/Teen1DayResultBody";
import { formatRefMatchTime } from "../../../utils/refMatchTime";

/**
 * Last Result items for Tembo Teenpatti 1-day (tteen) in the reference markup (LastResultsSection teen branch):
 *   span.resulta "A" (win 1) / span.resultb "B" (win 2) / "T" (win 0)
 * Click → .loader-overlay while the round detail loads, then the reference result modal.
 */
export default function TeenRefResults({ gameType, fallbackTitle }) {
  const apiType = String(gameType || "").toLowerCase().trim();
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(apiType);
        const res = response?.data?.data?.res;
        if (Array.isArray(res)) setLastResults(res);
      } catch (e) {
        console.error("Error fetching last results:", e);
      }
    };
    fetchLastResults();
    const interval = setInterval(fetchLastResults, 5000);
    return () => clearInterval(interval);
  }, [apiType]);

  const handleResultClick = async (mid) => {
    if (loading || !mid) return;
    setLoading(true);
    try {
      const response = await getDetailResults(apiType, String(mid));
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) {
        setDetailResult(t1);
        setShowModal(true);
      }
    } catch (e) {
      console.error("Error fetching detail results:", e);
    }
    setLoading(false);
  };

  return (
    <>
      {lastResults.map((r, i) => {
        const win = String(r?.win);
        return (
          <span
            key={`${r?.mid}-${i}`}
            className={win === "1" ? "resulta" : win === "2" ? "resultb" : undefined}
            onClick={() => handleResultClick(r?.mid)}
          >
            {win === "1" ? "A " : " "}
            {win === "2" ? "B " : " "}
            {win === "0" ? "T" : ""}
          </span>
        );
      })}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector(".page-content") || document.body)}
      <RefResultModal
        show={showModal && !!detailResult}
        onHide={() => setShowModal(false)}
        title={`${detailResult?.ename || fallbackTitle} Result`}
        roundId={detailResult?.rid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        {detailResult && <Teen1DayResultBody t1={detailResult} />}
      </RefResultModal>
    </>
  );
}
